<div
    #backdropClose
    class="backdrop-close"
    (click)="hideAppSwitcherMenu()"
></div>

<div
    class="app-switcher-container"
    [style.align-items]="align"
    [style.justify-content]="align"
>
    <div [matTooltip]="this.getAppButtonTooltip()">
        <!-- Currently opens GravityZone directly, switch to (click)='showAppSwitcherMenu()' after adding more apps -->
        <button
            #appsButton
            mat-icon-button
            class="apps-button"
            (click)="openGravityZone()"
            [disabled]="!isUserUsingSso()"
        >
            <mat-icon>apps</mat-icon>
        </button>
    </div>

    <div
        #appsMenu
        class="switcher-floating-menu"
    >
        <section class="header">
            <button
                mat-icon-button
                class="apps-button hide"
                (click)="hideAppSwitcherMenu()"
            >
                <mat-icon>apps</mat-icon>
            </button>
        </section>

        <section class="body">
            <button
                class="app-button"
                (click)="openGravityZone(); hideAppSwitcherMenu()"
            >
                <span class="app-button-icon ds-icon-companies"></span>
                <span class="app-button-text text-wrap-auto">Gravity Zone</span>
            </button>
        </section>
    </div>
</div>
